module.exports = __webpack_public_path__ + "static/media/error.5265a568.svg";